import { Skeleton } from '@mui/material';
import injectStores from '../RootStore/injectStores';
import { computed } from 'mobx';
import React from 'react';
import ViewStore from 'stores/ViewStore';

interface SkeletonCardHeaderProps {
  viewStore?: ViewStore;
  height?: number;
  width?: number;
}

const SkeletonCardHeader = injectStores(
  ({ viewStore, width }: SkeletonCardHeaderProps) => {
    const { cardHeaderSize, cardBodySize, isMobile } = viewStore || {};

    const skeletonWidth = computed(() => {
      if (width) return width;
      if (!cardBodySize?.width || !cardHeaderSize?.width) return 0;
      return isMobile ? cardBodySize.width - 15 : cardBodySize.width + 24;
    }).get();

    return (
      <Skeleton
        animation="wave"
        variant="rounded"
        width={skeletonWidth}
        height={cardHeaderSize?.height}
      />
    );
  }
);

export default SkeletonCardHeader;
